import { Directive, HostListener, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
    selector: 'input[type=file][formControlName],input[type=file][formControl]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileValueAccessorDirective),
            multi: true,
        },
    ],
})
export class FileValueAccessorDirective implements ControlValueAccessor {
    private onChange: (value: any) => void = () => {};
    private onTouched: () => void = () => {};

    @HostListener('change', ['$event.target.files'])
    handleChange(files: FileList): void {
        const file = files && files.length ? files[0] : null;
        this.onChange(file);
    }

    @HostListener('blur')
    handleTouched(): void {
        this.onTouched();
    }

    // Este método NO debe escribir nada en el input, solo se ignora
    writeValue(_: any): void {}

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
